<template>
    <div class="user-info">
      <div class="user-info-top">
        <div class="user-info-top-left">
          <line-input
            title="医师"
            :initalValue="model.initialReviewer"
            @onInput="onInputInput"
          ></line-input>
          <line-input
            title="科室"
            :initalValue="model.initialDepartment"
            @onInput="onInputInput"
          ></line-input>
          <button
            class="user-info-top-left-button noPrint"
            data-html2canvas-ignore="true"
            @click="onSaveClick"
          >
            保存
          </button>
        </div>
        <div style="flex: 1"></div>
        <p class="user-info-top-right" v-if="model.reportTemplateType !== 34">
          {{ model.createDate }}
        </p>
      </div>
    </div>
  </template>
  
  <script>
  import LineInput from "@c/report-detail/user-info/line-input.vue";
  import NewLineInput from "@c/report-detail/user-info/new-line-input.vue";
  export default {
    components: {
      LineInput,
      NewLineInput,
    },
  
    props: {
      model: Object,
    },
    computed: {
  
     
    },
  
    methods: {
      onInputInput(title, value) {
        this.$emit("onInputInput", title, value);
      },
      onSaveClick() {
        this.$emit("onSaveClick");
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .user-info {
    margin-bottom: rem(20);
    margin-top: rem(20);
  
    &-top {
      height: rem(40);
      margin-top: rem(10);
      margin-bottom: rem(10);
      display: flex;
      align-items: center;
      justify-content: space-between;
  
      &-left {
        display: flex;
        align-items: center;
  
        .line-input {
          width: 27%;
        }
  
        &-button {
          color: white;
          background-color: #16d585;
          font-size: rem(12);
          border-radius: rem(4);
          width: rem(50);
          height: rem(25);
          margin-left: rem(20);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
  
      &-left-wide {
        display: flex;
        align-items: center;
        margin-left: auto;
  
        .line-input {
          width: 27%;
        }
  
        &-button {
          color: white;
          background-color: #16d585;
          font-size: rem(12);
          border-radius: rem(4);
          width: rem(50);
          height: rem(25);
          margin-left: rem(20);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
  
      &-left-extra-wide {
        display: flex;
        align-items: center;
  
        .line-input {
          width: 50%;
        }
  
        &-button {
          color: white;
          background-color: #16d585;
          font-size: rem(12);
          border-radius: rem(4);
          width: rem(50);
          height: rem(25);
          margin-left: rem(20);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
  
      &-right {
        color: black;
        font-size: rem(14);
        margin-right: rem(12);
        white-space: nowrap;
      }
    }
  }
  
  @media print {
    .noPrint {
      display: none;
      background-color: white !important;
    }
  }
  </style>
  